import React from 'react';
import GenericTabs from 'components/navigation/Tabs/Tabs';
import { NsKey } from 'enums/NsKey';
import { useConfigTabs } from 'components/navigation/Tabs/useConfigTabs';
import { BranchCode } from 'api/risk';
import { ContractInfosProvider, useContractInfosState } from './ContractInfosContext';

interface ContractInfosProps {
  branchCode: BranchCode;
  contractId: string;
}

// Composant interne qui utilise le contexte
const ContractInfosContent: React.FC = () => {
  const { tabs } = useContractInfosState();

  const {
    activeTab,
    setActiveTab,
    visibleTabs,
    getTabLabel
  } = useConfigTabs(tabs, {
    defaultTab: 1,
    translationNamespaces: [NsKey.Contract, NsKey.Common],
  });

  return (
    <div className='border rounded-xl px-4 py-2'>
      <GenericTabs defaultTab={activeTab} onChange={setActiveTab}>
        {/* Génération dynamique des onglets */}
        {visibleTabs.map(tab => (
          <GenericTabs.Item
            key={tab.id}
            label={getTabLabel(tab)}
            value={tab.id}
            disabled={tab.disabled}
            className="flex justify-center font-semibold w-full"
          />
        ))}
        {/* Génération dynamique du contenu */}
        {visibleTabs.map(tab => (
          <GenericTabs.Content key={tab.id} value={tab.id}>
            <div className='p-4'>
              {tab.content}
            </div>
          </GenericTabs.Content>
        ))}
      </GenericTabs>
    </div>
  );
};

// Composant principal qui fournit le contexte
const ContractInfos: React.FC<ContractInfosProps> = ({ branchCode, contractId }) => {
  return (
    <ContractInfosProvider branchCode={branchCode} contractId={contractId}>
      <ContractInfosContent />
    </ContractInfosProvider>
  );
};

export default ContractInfos;
